const firebaseConfig = {
    apiKey: "AIzaSyBTNrsUQVb_EyJvlAGuDoA8zymmJmL6ttw",
    authDomain: "volunteer-network-websit-1fe53.firebaseapp.com",
    projectId: "volunteer-network-websit-1fe53",
    storageBucket: "volunteer-network-websit-1fe53.appspot.com",
    messagingSenderId: "103356436859",
    appId: "1:103356436859:web:abc6e4630aec4b92e26dde"
  };
  export default firebaseConfig;